export default __webpack_public_path__ + "static/media/questionMark.32c7b24e.svg";